import { ROUTES } from "@/constants/routes";
import { useAppNavigate } from "@/hooks/pane-routing";
import { route } from "@/utils/route";
import { useCallback } from "react";

/** Opens `SkillPane` for a skill id (`"new"` for create mode) in the right pane. */
export function useOpenSkill() {
  const appNavigate = useAppNavigate();

  return useCallback(
    (skillId: string) => {
      if (!skillId) return;
      appNavigate({
        pane: "rightPane",
        to: route(ROUTES.SKILLS.SHOW, { id: skillId }),
      });
    },
    [appNavigate],
  );
}
